import ComprobanteInfoStore from './ComprobanteInfoStore';
import ComprobanteListStore from './ComprobanteListStore';
import ComprobanteCreateStore from './ComprobanteCreateStore';
import ComprobanteCancellationStore from './ComprobanteCancellationStore';

const ComprobanteStore = {
  info: ComprobanteInfoStore,
  list: ComprobanteListStore,
  create: ComprobanteCreateStore,
  cancel: ComprobanteCancellationStore,
};

export default ComprobanteStore;
